import React, { Component } from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core/styles";
import { style } from "./styles";
import Header from "../../partials/header";
import Loading from "../loading";
import TableFormat from "../../partials/TableFormat";
import { formatDate, isJsonString } from "../../utils/setting";
import EditForm from "./form";
import { TableRow, TableCell, Collapse } from "@material-ui/core";
import Snackbar from "../snackbar";
const headCells = [
  {
    key: "englishName",
    numeric: false,
    disablePadding: false,
    label: "list_plugin_category_english_name",
  },
  {
    key: "name",
    numeric: false,
    disablePadding: false,
    label: "list_plugin_category_name",
  },
  {
    key: "key",
    numeric: false,
    disablePadding: false,
    label: "list_plugin_category_key",
  },
  {
    key: "createdAt",
    numeric: false,
    disablePadding: false,
    label: "list_plugin_category_createdAt",
  },
  {
    key: "updatedAt",
    numeric: false,
    disablePadding: false,
    label: "list_plugin_category_updatedAt",
  },
];
export class PluginCategory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedCategory: {},
      noRecordCategory: true,
      collapse: [],
    };
  }
  async componentDidMount() {}
  getPluginCategory = async (payload) => {
    this.loading.startLoading();
    let result = await this.props.getPluginCategory(payload);
    if (result && Array.isArray(result) && result.length !== 0)
      this.setState({ noRecordCategory: false });
    this.loading.stopLoading();
  };
  renderCollapse = (row, index) => {
    const { listPluginCategory } = this.props;
    const { collapse = [] } = this.state;
    return (
      <TableRow key={index}>
        <TableCell colSpan={headCells.length + 1} padding={"none"}>
          <Collapse in={collapse[index]} unmountOnExit>
            <EditForm
              data={listPluginCategory[index]}
              handleUpdate={this.handleUpdate}
            />
          </Collapse>
        </TableCell>
      </TableRow>
    );
  };
  handleUpdate = async (data) => {
    let { t } = this.props;
    this.loading.startLoading();
    let result = await this.props.updatePluginCategory(data);
    this.loading.stopLoading();
    if (result.code === 1) {
      this.handleOpenCollapes(-1);
      this.getPluginCategory();
      this.mSnackbar.handleClick(t("update_successful"));
    } else this.mSnackbar.handleClick(result.error, "error");
  };
  handleOpenCollapes = (id) => {
    const { listPluginCategory = [] } = this.props;
    const collapse = this.state.collapse;
    for (var i = 0; i <= listPluginCategory.length; i++) {
      if (i === id) {
        collapse[i] = !collapse[i];
      } else {
        collapse[i] = false;
      }
    }
    this.setState(collapse);
  };
  handleDelete = async (selected) => {
    this.loading.startLoading();
    let check = await this.props.deletePluginCategory({
      categoryIds: selected,
    });
    if (check && check.code === 1) {
      this.loading.stopLoading();
      return true;
    } else {
      this.loading.stopLoading();
      return false;
    }
  };
  render() {
    const { t, listPluginCategory = [], total, count } = this.props;
    let { collapse } = this.state;
    return (
      <>
        <Header
          session={t("sidebar_superadmin")}
          title={t("plugin_category")}
          // backIcon={true}
          // actionBack={() => this.props.history.push("/PluginCategory/list")}
          button={t("create_plugin_category")}
          actionButton={() => this.props.history.push("/pluginCategory/create")}
        />
        <Snackbar
          color="white"
          onRef={(snackbar) => (this.mSnackbar = snackbar)}
        />
        {/* <Paper> */}
        <Loading onRef={(id) => (this.loading = id)} />
        <TableFormat
          onRef={(ref) => (this.mTable = ref)}
          orderBy=""
          title={t("list_plugin_category")}
          contentDialog={t("do_you_want_to_delete_selected_plugin_category")}
          totalCount={total}
          count={count}
          placeholder={t("plugin_category_search_by_name")}
          // hiddenInfoRcord={true}
          showFilter={false}
          // hiddenPagination={true}
          headCells={headCells}
          size={"medium"}
          isCollapse={true}
          collapse={collapse}
          renderCollapse={this.renderCollapse}
          handleOpenCollapes={this.handleOpenCollapes}
          hiddenSearch={false}
          showCheckBox={true}
          onDelete={this.handleDelete}
          showFilterBranch={false}
          getList={this.getPluginCategory}
          rows={listPluginCategory.map((row, index) => {
            if (isJsonString(row.name)) row.name = JSON.parse(row.name);
            return {
              id: row.categoryId,
              englishName: row.name && row.name.en,
              name: row.name && row.name.vi,
              key: row.key,
              createdAt: formatDate(row.createdAt),
              updatedAt: formatDate(row.updatedAt),
            };
          })}
        />
      </>
    );
  }
}

const mapState = (state) => ({
  listPluginCategory: state.pluginCategory.listPluginCategory,
  total: state.pluginCategory.total,
  count: state.pluginCategory.count,
});

const mapDispatch = (dispatch) => ({
  getPluginCategory: dispatch.pluginCategory.getPluginCategory,
  deletePluginCategory: dispatch.pluginCategory.deletePluginCategory,
  updatePluginCategory: dispatch.pluginCategory.updatePluginCategory,
});

export default connect(
  mapState,
  mapDispatch
)(
  translate("translations")(withStyles(style, { withTheme: 0 })(PluginCategory))
);
